<template lang="pug">
matchDetails(
  v-if="selectedId!==null"
  :matchId="selectedId"
  :league="selectedLeague"
  :home="selectedHome"
  :away="selectedAway"
  @deselect="deselect"
  )
div.container-fluid.animated.fadeIn(v-else-if="selectedId===null")
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/rb")
          i.fas.fa-running
          span.ml-1 {{ $t("ui.running_ball") }}
      b-breadcrumb-item
        router-link(to="/rb/matchfeed")
          i.fas.fa-rss
          span.ml-1 {{ $t("ui.match_feed") }}
  div.row
    div.col-md-12
      div.card
        div.card-header
          div.row
            div.col-md-12.mb-1
              div.form-row
                div.col-md-3.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $tc("ui.leagues", 1) }}
                    DebounceInput(required type="text"
                      v-model="leagueSearch"
                      :placeholder="$t('message.search_by_league_name')"
                    )
                div.col-md-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $t("ui.home") }}
                    DebounceInput(required type="text"
                      v-model="hometeamSearch"
                      :placeholder="$t('message.search_by_home_team')"
                    )
                div.col-md-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $t("ui.away") }}
                    DebounceInput(required type="text"
                      v-model="awayteamSearch"
                      :placeholder="$t('message.search_by_away_team')"
                    )
                div.col-md-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $t("ui.from") }}
                    date-picker(v-model="startDate" :config="locale")
                div.col-md-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $t("ui.to") }}
                    date-picker(v-model="endDate" :config="locale")
          div.row
            div.col-md-12.mb-1
              div.form-row
                div.col-md-3.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $t("ui.play_state") }}
                    b-form-select(v-model="playstate")
                      //- template(slot="first")
                      //-   option(:value="null" disabled) {{ $t("message.set_play_state") }}
                      option(:value="null") {{ $t("ui.all") }}
                      option(value="0") 0
                      option(value="1") 1
                      option(value="2") 2
                      option(value="3") 3
                div.col-md-3.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $t("ui.linked") }}
                    b-form-select(v-model="match_map")
                      //- template(slot="first")
                      //-   option(:value="null" disabled) {{ $t("message.set_match_map") }}
                      option(:value="null") {{ $t("ui.all") }}
                      option(value="0") {{ $t("ui.not_mapped") }}
                      option(value="1") {{ $t("ui.mapped") }}
                div.col-md-2.mb-1
                  SubmitButton(
                    :loading="loading"
                    icon="fa fa-search"
                    :text="$t('ui.search')"
                    type="button"
                    @click="search"
                    variant="success"
                    size="sm"
                    ).mr-2
        div.card-body
          div.row
            div.col-md-10
              b-pagination.float-left(
                size="sm"
                hide-ellipsis
                :total-rows="matchFeedTotalRow"
                :per-page="getPageSize"
                v-model="currentMatchFeedPage"
                @input="changedPage($event)").mb-1
            div.col-md-2
              b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize")
                b-input(:value="matchFeedTotalRow" readonly)
          div.row.clusterize
            div.col-md-12.clusterize-scroll
              table.tablex(style="width: 100%;" v-columns-resizable)
                thead
                  tr
                    th.text-center.sticky-position(width=70)
                      span {{ $t("ui.id") }}
                    th.text-center.sticky-position(width=130)
                      span {{ $t("ui.match_time") }}
                    th.sticky-position(width=200)
                      span {{ $tc("ui.leagues", 1) }}
                    th.sticky-position(width=200)
                      span {{ $t("ui.home") }}
                    th.sticky-position(width=200)
                      span {{ $t("ui.away") }}
                    th.sticky-position(width=80)
                      span {{ $t("ui.play_state") }}
                    th.text-center.sticky-position(width=120)
                      span {{ $t("ui.play_time") }}
                    th.sticky-position
                      span {{ $t("ui.info") }}
                    th.sticky-position
                      span {{ $t("ui.last_info") }}
                    th.text-center.sticky-position(width=60)
                      span {{ $t("ui.linked") }}
                tbody.clusterize-content
                  tr(v-if="filteredMFList.length == 0")
                    td(colspan="10").text-center
                      span {{ $t('message.no_data_available') }}
                  tr(v-for="(item, index) in filteredMFList")
                      td
                        span
                          b-link.clickable(href="javascript:void(0);" @click="onSelect(item)") {{ item.RTFMatchID }}
                      //- td.match-link.text-center( @click="onSelect(item)")
                      //-   span {{ item.RTFMatchID }}
                      td.text-center
                        span {{ `${item.MatchTime.split('T')[0]} ${item.MatchTime.split('T')[1]}` }}
                      td
                        span(:title="item.League") {{ item.League }}
                      td
                        span(:title="item.Home") {{ item.Home }}
                      td
                        span(:title="item.Away") {{ item.Away }}
                      td.text-center
                        span {{ item.playStateId }}
                      td.text-center
                        span {{ Math.floor(item.currentPlaytime/60000) }}
                      td
                        span(:title="item.Info") {{ item.Info }}
                      td
                        span(:title="item.LastInfo") {{ item.LastInfo }}
                      td.text-center
                        span
                          i(:class="{'fas fa-check text-info': item.IsLinked, 'fas fa-times text-warning': !item.IsLinked  }")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import matchDetails from "@/components/matchFeed/matchDetailsOld.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    matchDetails
  },
  data: () => ({
    loading: false,
    filterBy: "id",
    mfList: [],
    mfSearch: "",
    leagueSearch: "",
    hometeamSearch: "",
    awayteamSearch: "",
    selected: [],
    selectedId: null,
    selectedLeague: null,
    selectedHome: null,
    selectedAway: null,
    playstate: null,
    match_map: null,
    sortKey: "league_name",
    sortType: "asc",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    startDate: new Date(),
    endDate: new Date(),
    locale: {
      format: "YYYY-MM-DD",
      useCurrent: true
    },
    matchFeedTotalRow: 0,
    currentMatchFeedPage: 1
  }),
  computed: {
    today() {
      return this.$moment(new Date).format('YYYY-MM-DD');
    },
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    filteredMFList() {
      return this.mfList.filter(mf => {
        if (this.filterBy === "name") {
          return mf.League.toLowerCase().indexOf(this.mfSearch.toLowerCase()) > -1;
        } else {
          return mf.RTFMatchID.toString().indexOf(this.mfSearch) > -1;
        }
      });
    }
  },
  mounted: function() {
    this.startDate = this.endDate = this.today;
  },
  methods: {
    search() {
      this.mfList = [];
      this.getMatchFeedList();
    },
    getMatchFeedList: function() {
      let url = config.getMatchFeedListUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.matchfeed,
        date_from: this.$moment(this.startDate).format("YYYY-MM-DD"),
        date_to: this.$moment(this.endDate).format("YYYY-MM-DD"),
        league_name: this.leagueSearch,
        home_team_name: this.hometeamSearch,
        away_team_name: this.awayteamSearch,
        playstate: this.playstate,
        match_map: this.match_map,
        page_number: this.currentMatchFeedPage,
        page_size: this.getPageSize
      };

      this.$http.post(url, json).then(
        function(response) {
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.mfList = response.data.tbl_match_feed_list;
                this.matchFeedTotalRow = this.mfList.length > 0 ? this.mfList[0].totalrows : 0;
              } else {
                this.$helpers.handleFeedback(this.feedback.status);
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showToast(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showToast(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    onSelect(e) {
      this.selectedId = e.RTFMatchID;
      this.selectedLeague = e.League;
      this.selectedHome = e.Home;
      this.selectedAway = e.Away;
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentMatchFeedPage = 1;
      this.getMatchFeedList();
    },
    changedPage: function(pageNo) {
      this.currentMatchFeedPage = pageNo;
      this.getMatchFeedList();
    },
    deselect() {
      this.selectedId = null
    }
  }
};
</script>
